module.exports = __webpack_public_path__ + "img/LocQueryS1Page.0ce88d31.png";